module.exports = __webpack_public_path__ + "img/logo_obligasi.94b2ef16.png";